import { View } from "binder"
import { VmFunctionEditorViewModel } from "./vmFunctionEditor-viewModel"

export class VmFunctionEditorView extends View<VmFunctionEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-7410C805-0F1E-45C6-B0FF-527F0C23F462"
    }
    loadHtml(): string {
        let element = require('./vmFunctionEditor.html').default;
        let style = require('./vmFunctionEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];

}
